import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Button, Modal, PopUpMessage } from "..";
import { Tabs } from "rsuite";
import { CodeBlock } from 'react-code-blocks';
import { copyToClipboard } from "./utils";
const DownloadModal = (props) => {
    const { size, open, setOpen, action, objectType, filter, source, fields, totalSize } = props;
    const stringifyFilter = (filter) => {
        if (!filter) {
            return 'None';
        }
        // @ts-ignore
        return JSON.stringify(filter, (key, value) => {
            if (typeof value === 'boolean') {
                return value ? 'True' : 'False';
            }
            return value;
        }).replace(/"True"/g, 'True').replace(/"False"/g, 'False');
    };
    const sourceToUse = source || 'portal';
    const SDKText = `from tol.core import DataSourceFilter
from tol.sources.${sourceToUse} import ${sourceToUse}

src = ${sourceToUse}()
f = DataSourceFilter(
    and_ = ${stringifyFilter(filter?.and_)}
)
objs = src.get_list('${objectType}', object_filters=f) 
  `;
    const CLICommand = `
tol data \
--source=${sourceToUse || 'portal'} \
--operation=list \
--type=${objectType} \
--filter='${JSON.stringify(filter) || '{"and":{}}'}' \
--fields=${fields.join(',')} \
--output=tsv 
  `;
    const onClick = (text) => {
        copyToClipboard(text.trim());
        PopUpMessage({
            type: 'success',
            message: 'Copied to clipboard',
        });
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, { size: size, open: open, setOpen: setOpen, children: _jsxs(Tabs, { defaultActiveKey: "1", children: [_jsx(Tabs.Tab, { eventKey: "1", title: "Spreadsheet", children: _jsx("div", { className: "tol-download-modal-body", children: _jsx(Button, { type: "success", text: "Download as Spreadsheet", onClick: () => {
                                    action();
                                    setOpen(false);
                                }, icon: "download", disabledTooltip: totalSize >= 1
                                    ? "Only 10,000 results can currently be downloaded as a spreadsheet."
                                    : undefined, disabled: totalSize >= 10000 }) }) }), _jsxs(Tabs.Tab, { eventKey: "2", title: "SDK", children: [_jsx("div", { className: "tol-download-modal-code", children: _jsx(CodeBlock, { text: SDKText, language: "python", showLineNumbers: false }) }), _jsx("br", {}), _jsx(Button, { onClick: () => onClick(SDKText), icon: "copy", text: "Copy to Clipboard" })] }), _jsxs(Tabs.Tab, { eventKey: "3", title: "CLI", children: [_jsx("div", { className: "tol-download-modal-code", children: _jsx(CodeBlock, { text: CLICommand, language: "bash", showLineNumbers: false }) }), _jsx("br", {}), _jsx(Button, { onClick: () => onClick(CLICommand), icon: "copy", text: "Copy to Clipboard" })] })] }) }) }));
};
export default DownloadModal;
